(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CostType', CostType);

    CostType.$inject = ['$resource'];

    function CostType ($resource) {
        var resourceUrl =  'api/cost-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
